export default "__VITE_ASSET__DHRqtceS__"